import { CategoryRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { useAsyncAction } from 'app/services';
import { geofenceOptionsUpdate } from 'app/store/map';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
const MapLeafletGeofenceShapeChangeDialog = (props) => {
    const { geofenceChangedItem } = useSelector((state) => state.map);
    const { open, onClose } = props;
    const { asyncAction: changeSubmit, isLoading: isChangeLoading, isSuccessful: isChangeSuccessful, isError: isChangeError, } = useAsyncAction(geofenceOptionsUpdate, [open]);
    const handleChangeClick = () => {
        const params = {
            type: 'shape',
            latitude: geofenceChangedItem.latitude,
            longitude: geofenceChangedItem.longitude,
        };
        switch (geofenceChangedItem.shape) {
            case 'Circle':
                params.shape = 'Polygon';
                params.radius = geofenceChangedItem.radius;
                params.edges = config.mapGeofenceOptions.polygonEdges;
                break;
            case 'Polygon':
                params.shape = 'Circle';
                params.radius = config.mapGeofenceOptions.defaultRadius;
                params.edges = config.mapGeofenceOptions.circleEdges;
                break;
        }
        changeSubmit(geofenceChangedItem.id, params);
    };
    useEffect(() => {
        if (isChangeSuccessful) {
            onClose();
        }
    }, [isChangeSuccessful]);
    return (React.createElement(Dialog, { maxWidth: 'md', fullWidth: true, open: open, onClose: onClose, sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2.5),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(1.5),
            },
            '.MuiDialogTitle-root .MuiButtonBase-root': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2.5),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2.5),
                justifyContent: 'flex-end',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                'path, circle': {
                    fill: theme.palette.primary.main,
                },
            },
            '.MuiAlert-root': {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(CategoryRounded, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'p' }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u0438\u0434 \u0433\u0435\u043E\u0437\u043E\u043D\u044B")),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(Typography, { variant: 'caption' }, "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u0438\u0434 \u0433\u0435\u043E\u0437\u043E\u043D\u044B?"),
                !isChangeLoading && isChangeError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")))),
        React.createElement(DialogActions, null,
            React.createElement(LoadingButton, { variant: 'contained', onClick: handleChangeClick, loading: isChangeLoading, disableElevation: true }, "\u0414\u0430"),
            React.createElement(LoadingButton, { variant: 'outlined', onClick: onClose, disableElevation: true }, "\u041D\u0435\u0442"))));
};
export default MapLeafletGeofenceShapeChangeDialog;
